import { logger } from '@/utils/logger'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

/**
 * リビジョンID取得
 */
import { ApiFetchRevision } from '~/endpoints/ApiFetchRevision'

export const UNKNOWN_REVISION_ID = 'unknown'

export interface StateRevision {
  revision: string
}

export const state = (): StateRevision => ({
  revision: UNKNOWN_REVISION_ID,
})

@Module({
  name: 'apis/FetchRevision',
  stateFactory: true,
  namespaced: true,
})
export default class FetchRevision extends VuexModule {
  // States
  private state_: StateRevision = state()

  // Getters
  get result(): StateRevision {
    return this.state_
  }

  // Mutations
  @Mutation
  updateRevision(value: StateRevision) {
    this.state_ = value
  }

  static readonly MUTATION_NAME_UPDATE_STATE = 'updateRevision'

  // Actions
  @Action
  clear() {
    this.context.commit(FetchRevision.MUTATION_NAME_UPDATE_STATE, state())
  }

  @Action
  async fetchRevision(): Promise<boolean> {
    logger.trace('in: fetchRevision')
    const api = new ApiFetchRevision.Api()
    const response = await api.get<StateRevision>()
    if (response === null) {
      logger.error('fetchRevision: response is null')
      this.clear()
      return false
    }
    const revisionJson = response
    logger.info(`fetchRevision: revision=${revisionJson.revision}`)
    this.context.commit(FetchRevision.MUTATION_NAME_UPDATE_STATE, revisionJson)
    return true
  }
}
